let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("yYZTe")).then(() => parcelRequire('oVpHS'));